"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function OpacityCircle(_a) {
    var _b, _c;
    var dataKey = _a.dataKey, onClick = _a.onClick, props = __rest(_a, ["dataKey", "onClick"]);
    var cx = props.cx, cy = props.cy, fill = props.fill, width = props.width, height = props.height;
    var data = Object.keys(props.payload).reduce(function (p, c) {
        if (!c.includes(dataKey + "-data")) {
            return p;
        }
        return props.payload[dataKey + "-data"];
    }, null);
    if (!data) {
        return null;
    }
    return react_1.default.createElement("circle", { cx: cx, cy: cy, r: ((_b = data.meta) === null || _b === void 0 ? void 0 : _b.radius) || 10, strokeWidth: 2, stroke: fill, fill: fill, fillOpacity: ((_c = data.meta) === null || _c === void 0 ? void 0 : _c.opacity) || 1, width: width, height: height });
}
exports.OpacityCircle = OpacityCircle;
//# sourceMappingURL=OpacityCircle.js.map